/* eslint-disable @typescript-eslint/naming-convention */
export function convertPartnerDtoToAppDto(partnerResponseData) {
  const listImageUrl: any[] = [];
  const partnerBannerResponse = partnerResponseData.additional?.images;
  if (partnerBannerResponse?.length > 0) {
    for (const imageUrl of partnerBannerResponse) {
      listImageUrl.push({ image: { url: imageUrl } });
    }
  }

  return {
    id: partnerResponseData.id,
    name: partnerResponseData.name,
    uid: partnerResponseData.id,
    redirect_uri: partnerResponseData.redirect_uri,
    scopes: partnerResponseData.scopes,
    created_at: partnerResponseData.created_at,
    category: partnerResponseData.category,
    logo: { url: partnerResponseData.logo },
    short_description: partnerResponseData.additional?.short_description,
    description: partnerResponseData.additional?.description,
    price: partnerResponseData.additional?.price,
    website: partnerResponseData.additional?.support_website,
    support_phone: partnerResponseData.additional?.support_phone,
    support_email: partnerResponseData.additional?.support_email,
    oauth_application_images: listImageUrl,
    is_authorized: partnerResponseData.is_registered,
    partner_version: 2,
  };
}

export function convertPartnerDtoListToAppDtoList(partnerResponseData) {
  return partnerResponseData.map(convertPartnerDtoToAppDto);
}
